export default "__VITE_ASSET__DIMMoR2b__"